export const DEVTOOLS_MESSAGE_IDENTIFIER = '__ems-devtools__';
export const DEVTOOLS_HOOKS_IDENTIFIER = '__PULSE_DEVTOOLS_HOOKS__';
export const DEVTOOLS_LOCAL_STORAGE_KEY = 'enableEMSDevtools';
export const DEVTOOLS_PRINT_LOGS_TO_CONSOLE = 'printEMSLogsToConsole';